import { Component, Type } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {
  FieldType,
  FieldTypeConfig,
  FormlyFieldConfig,
  FormlyFieldProps,
  FormlyModule,
} from '@ngx-formly/core';
import { CustomErrorStateMatcher } from '../../utils/custom-error-state-matcher';

export interface FormlyInputFieldConfig extends FormlyFieldConfig<FormlyFieldProps> {
  type: 'input' | Type<InputComponent>;
}

@Component({
  selector: 'vectronic-formly-input',
  imports: [MatFormFieldModule, MatInputModule, ReactiveFormsModule, FormlyModule],
  templateUrl: './input.component.html',
  styles: [
    `
      mat-form-field {
        display: block;
      }

      span[matTextSuffix] {
        margin-left: 0.5rem;
      }

      span[matTextPrefix] {
        margin-right: 0.5rem;
      }
    `,
  ],
})
export class InputComponent extends FieldType<FieldTypeConfig<FormlyFieldProps>> {
  matcher = new CustomErrorStateMatcher();

  get type() {
    return this.props?.type || 'text';
  }

  preventNonNumericalInput(e: KeyboardEvent) {
    if (!e.key.match(/^[0-9.]+$/)) {
      e.preventDefault();
    }
  }

  preventExceedingAllowedRange(value: string) {
    if (!this.props) {
      return;
    }
    const numberValue = parseFloat(value);
    if (this.props.min && numberValue < this.props.min) {
      this.formControl.setValue(this.props.min);
    }
    if (this.props.max && numberValue > this.props.max) {
      this.formControl.setValue(this.props.max);
    }
  }
}
